module.exports = __webpack_public_path__ + "static/media/Privacy_Policy_v1.1.09c5d96f.pdf";